import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { HOME } from "@/constants/testIds";
import { ArrowRight } from "lucide-react";

const services = [
  { key: "hemming",       name: "Trouser Shortening",         desc: "Hems, breaks and cuffs on trousers and jeans.",
    img: "https://images.pexels.com/photos/1082529/pexels-photo-1082529.jpeg?auto=compress&cs=tinysrgb&w=800" },
  { key: "other",         name: "Suit Alterations",           desc: "Precision tailoring for a modern silhouette.",
    img: "https://images.pexels.com/photos/1300550/pexels-photo-1300550.jpeg?auto=compress&cs=tinysrgb&w=800" },
  { key: "resize",        name: "Dress Alterations",          desc: "Take-in, let-out, hems and re-fits for every dress.",
    img: "https://images.pexels.com/photos/985635/pexels-photo-985635.jpeg?auto=compress&cs=tinysrgb&w=800" },
  { key: "wedding_dress", name: "Wedding Dress Alterations",  desc: "Multi-fitting bridal service with bustle & stays.",
    img: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=800&q=80" },
  { key: "other",         name: "Jacket Alterations",         desc: "Sleeves, shoulders, taper and lining repairs.",
    img: "https://images.unsplash.com/photo-1593030761757-71fae45fa0e7?w=800&q=80" },
  { key: "other",         name: "Shirt Alterations",          desc: "Collar, cuff and body-shape refinement.",
    img: "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=800&q=80" },
  { key: "zipper",        name: "Zip Repairs",                desc: "Invisible zips, standard zips and full replacements.",
    img: "https://images.pexels.com/photos/4622411/pexels-photo-4622411.jpeg?auto=compress&cs=tinysrgb&w=800" },
  { key: "dry_cleaning",  name: "Dry Cleaning",               desc: "Evening pickup from your door, from 6:30pm.",
    img: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&q=80",
    href: "/pickup" },
];

const galleryImgs = [
  "https://images.pexels.com/photos/4620619/pexels-photo-4620619.jpeg?auto=compress&cs=tinysrgb&w=900",
  "https://images.pexels.com/photos/4622412/pexels-photo-4622412.jpeg?auto=compress&cs=tinysrgb&w=900",
  "https://images.unsplash.com/photo-1544441893-675973e31985?w=900&q=80",
  "https://images.pexels.com/photos/4622410/pexels-photo-4622410.jpeg?auto=compress&cs=tinysrgb&w=900",
  "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=900&q=80",
  "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=900&q=80",
];

export default function Home() {
  const [promos, setPromos] = useState([]);
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    api.get("/promotions").then(r => setPromos(r.data)).catch(() => {});
    api.get("/reviews").then(r => setReviews(r.data.slice(0, 6))).catch(() => {});
  }, []);

  return (
    <div className="bg-[#FFFFFF]">
      {/* Promo banner */}
      {promos[0] && (
        <div data-testid={HOME.promoBanner} className="bg-[#0F172A] text-[#FFFFFF] text-center py-3 text-xs md:text-sm tracking-wide">
          <span className="overline text-white/70 mr-3">Now on</span>
          <span className="text-white font-medium">{promos[0].title}</span>
          <span className="mx-3 opacity-40">·</span>
          <span className="opacity-80">{promos[0].body}</span>
        </div>
      )}

      {/* Hero */}
      <section className="relative overflow-hidden top-section-bg">
        <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-20 md:pb-32 grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-6">
            <div className="overline">Est. Rhodes · Sydney</div>
            <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.05] mt-6">
              A fitting<br/>
              <em className="italic">for every</em><br/>
              chapter.
            </h1>
            <p className="mt-8 text-lg text-[#4A4A4A] max-w-md leading-relaxed">
              Bridal, formal, and everyday alterations by Hedieh — four Sydney ateliers, one obsession with fit.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/book" data-testid={HOME.bookNowHero}
                    className="group inline-flex items-center gap-3 px-8 py-4 bg-[#D4AF37] text-[#0F172A] text-xs uppercase tracking-[0.25em] hover:bg-[#B8941F]">
                Book a Fitting <ArrowRight size={16} className="transition-transform group-hover:translate-x-1"/>
              </Link>
              <Link to="/track" className="inline-flex items-center gap-3 px-8 py-4 border border-[#0F172A] text-xs uppercase tracking-[0.25em] hover:bg-[#0F172A] hover:text-[#FFFFFF]">
                Track Your Order
              </Link>
            </div>
          </div>
          <div className="md:col-span-6 relative">
            <div className="relative aspect-[4/5] overflow-hidden image-hover">
              <img src="https://images.pexels.com/photos/4620617/pexels-photo-4620617.jpeg?auto=compress&cs=tinysrgb&w=1200"
                   alt="Tailor taking measurements" className="w-full h-full object-cover"/>
            </div>
            <div className="hidden md:block absolute -bottom-8 -left-8 bg-[#FFFFFF] border border-[#E2E8F0] p-8 max-w-xs">
              <div className="overline">Four ateliers</div>
              <div className="font-serif-display text-2xl mt-2">Rhodes · Ashfield · West Ryde · Charlestown</div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" data-testid={HOME.servicesSection} className="bg-[#F8FAFC] border-y border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-32">
          <div className="flex items-end justify-between mb-16 flex-wrap gap-4">
            <div>
              <div className="overline">Services</div>
              <h2 className="font-serif-display text-4xl md:text-5xl mt-3">Considered work,<br/>quietly perfected.</h2>
            </div>
            <p className="text-[#4A4A4A] max-w-sm">Every piece is treated as a portrait. Quotes are always tailored — no fixed pricing, only fair prices for skilled work.</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((s) => (
              <Link key={s.name}
                    to={s.href || `/book?service=${s.key}`}
                    className="service-card group bg-white border border-[#E2E8F0] flex flex-col overflow-hidden">
                <div className="aspect-[4/3] overflow-hidden image-hover bg-[#F8FAFC]">
                  <img src={s.img} alt={s.name} className="w-full h-full object-cover"/>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="font-serif-display text-xl">{s.name}</div>
                  <p className="text-sm text-[#4B5563] mt-2 flex-1">{s.desc}</p>
                  <div className="mt-5 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#D4AF37] group-hover:gap-3 transition-all">
                    Book this <ArrowRight size={12}/>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section id="gallery" data-testid={HOME.gallerySection} className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-32">
        <div className="mb-16 flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="overline">Portfolio</div>
            <h2 className="font-serif-display text-4xl md:text-5xl mt-3">Before &amp; After</h2>
          </div>
          <p className="text-[#4A4A4A] max-w-sm">A quiet look at recent work from the studio floor.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {galleryImgs.map((src, i) => (
            <div key={i}
                 className={`image-hover overflow-hidden ${i === 0 || i === 4 ? "md:col-span-2 md:row-span-2 aspect-square" : "aspect-[3/4]"}`}>
              <img src={src} alt={`Work sample ${i + 1}`} className="w-full h-full object-cover"/>
            </div>
          ))}
        </div>
      </section>

      {/* Reviews */}
      <section id="reviews" data-testid={HOME.reviewsSection} className="bg-[#0F172A] text-[#FFFFFF]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-32">
          <div className="overline text-[#D4AF37]">Words from clients</div>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-4 max-w-3xl">
            <em className="italic">"</em>Hedieh has an eye for the smallest details — I felt beautiful.<em className="italic">"</em>
          </h2>
          <div className="grid md:grid-cols-3 gap-8 mt-20">
            {reviews.slice(0, 3).map((r) => (
              <div key={r.id} className="border-t border-white/15 pt-8">
                <div className="text-[#D4AF37] tracking-widest">{"★".repeat(r.rating)}</div>
                <p className="mt-5 text-[#F8FAFC]/80 leading-relaxed">"{r.text}"</p>
                <div className="overline mt-6 text-[#D4AF37]">{r.customer_name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-5xl mx-auto px-6 md:px-10 py-20 md:py-32 text-center">
        <div className="overline">Ready when you are</div>
        <h2 className="font-serif-display text-5xl md:text-6xl mt-6">Book your fitting today.</h2>
        <p className="mt-6 text-[#4A4A4A] max-w-xl mx-auto">Upload a photo of the garment, choose a shop, and we'll take care of the rest. Deposits are quoted per piece — always fair, always transparent.</p>
        <Link to="/book" className="inline-flex items-center gap-3 mt-10 px-10 py-4 bg-[#D4AF37] text-[#0F172A] text-xs uppercase tracking-[0.25em] hover:bg-[#B8941F]">
          Book a Fitting <ArrowRight size={16}/>
        </Link>
      </section>
    </div>
  );
}
